import React from "react";

function Home() {
    return (
        <div><h3>Home Page</h3></div>

    )
}

export default Home;
